<template>
    <Paper class="product-Main">
        <div class="productMaintenance">
            <el-row>
                <el-col :span="19">
                    <el-row>
                        <el-col class="productMaintenance-list">
                            <el-input v-model="inquireData['productCode']" @keyup.enter.native="searchChange" :placeholder="$translate('lang.E3202102220013', { defaultText: '产品编码' })"></el-input>
                        </el-col>
                        <el-col class="productMaintenance-list">
                            <el-input v-model="inquireData['productName']" @keyup.enter.native="searchChange" :placeholder="$translate('lang.E3202101260018', { defaultText: '产品名称' })"></el-input>
                        </el-col>
                        <el-col class="productMaintenance-list">
                            <el-select clearable v-model="inquireData['operateType']" :placeholder="$translate('lang.E3202103220026', { defaultText: '操作类型' })">
                                <el-option
                                    v-for="item in typeOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <div>
                            <el-button type="primary" :loading="loading" size="mini" @click="searchChange" icon='el-icon-search'>
                                {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                            </el-button>
                            <el-button @click="restSearchChange" size="mini" class="sn-search-reset-button">
                                {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                            </el-button>
                        </div>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <div>
            <enterLog-table
                ref="productTable"
                :pageTotal="productMaintenanceTotal"
                :tableData="productMaintenanceTableData"
                @pageChange="productMaintenancePage"
                @sizeChange="productMaintenanceSize"
                :config="productMaintenanceConfig">
                <div slot="page-module-btn">
                    <el-button type="primary" size="mini" @click="exportClick" icon="el-icon-upload2">
                        {{$translate('lang.E3202103220006', { defaultText: '导出' })}}
                    </el-button>
                </div>
            </enterLog-table>
        </div>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import enterLogTable from '../../../components/IdentityComponent/Main';
import productMaintenanceConfig from './config.js';
import { getProductionLog, exportType } from '../../../api/logManagement';
export default {
    name: 'productMaintenance',
    components: { Paper, enterLogTable },
    data() {
        return {
            productMaintenanceConfig: productMaintenanceConfig,
            inquireData: {
                productCode: '',
                productName: '',
                operateType: ''
            },
            loading: false,
            productMaintenanceTableData: [],
            productMaintenanceTotal: 0,
            typeOptions: [
                {
                    label: '新增',
                    value: '新增'
                },
                {
                    label: '编辑',
                    value: '编辑'
                },
                {
                    label: '启用',
                    value: '启用'
                },
                {
                    label: '停用',
                    value: '停用'
                }
            ],
            page: {
                pageSize: 10,
                pageNo: 1
            }
        };
    },
    methods: {
        restSearchChange() {
            this.inquireData['productCode'] = '';
            this.inquireData['productName'] = '';
            this.inquireData['operateType'] = '';
        },
        exportClick() {
            const params = {
                ...this.inquireData
            };
            const url = '/api-sn/product/productLog/export';
            const type = 'post';
            const name = this.$translate('lang.E3202103220027', { defaultText: '产品维护日志.xls' });
            exportType(params, url, type, name);
        },
        getData(params) {
            getProductionLog(params).then(res => {
                if (+res.code === 0) {
                    this.productMaintenanceTableData = res.data.list;
                    this.productMaintenanceTotal = res.data.totalCount;
                }
                this.loading = false;
            }).catch(res => {
                this.loading = false;
            });
        },
        searchChange() {
            this.$refs.productTable.$refs.page.pageState = false;
            this.page.pageNo = 1;
            this.productMaintenanceConfig.page.pageSize = this.page.pageSize;
            const params = {
                ...this.page,
                ...this.inquireData
            };
            this.loading = true;
            this.getData(params);
            this.$nextTick(() => {
                this.$refs.productTable.$refs.page.pageState = true;
            });
        },
        productMaintenanceSize(pageSize) {
            this.page['pageSize'] = pageSize;
            const params = {
                ...this.page,
                ...this.inquireData
            };
            this.getData(params);
        },
        productMaintenancePage(pageNo) {
            this.page['pageNo'] = pageNo;
            const params = {
                ...this.page,
                ...this.inquireData
            };
            this.getData(params);
        }
    }
};
</script>
<style lang="less">
.productMaintenance {
    margin-bottom: 20px;
    .productMaintenance-list {
        width: 190px;
        margin-right: 10px;
        .el-select {
            width: 100%;
        }
    }
}
.product-Main {
    .nPanel .el-table {
        height: calc(100vh - 180px) !important;
    }
    .nPanel .row-bg {
        margin-top: 20px;
    }
}
</style>